/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Full_Rosy_Cow_PlayInputs */

const en_full_rosy_cow_play = /** @type {(inputs: Full_Rosy_Cow_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comments status`)
};

const de_full_rosy_cow_play = /** @type {(inputs: Full_Rosy_Cow_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommentarstatus`)
};

/**
* | output |
* | --- |
* | "Comments status" |
*
* @param {Full_Rosy_Cow_PlayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const full_rosy_cow_play = /** @type {((inputs?: Full_Rosy_Cow_PlayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Full_Rosy_Cow_PlayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_full_rosy_cow_play(inputs)
	return de_full_rosy_cow_play(inputs)
});